import { FC, useEffect, useState } from 'react';
import Select, { useStateManager } from 'react-select';
interface CbMultiSelectProps {
  menuOpenWhileMultiSelect?: boolean;
  selectProps?: object;
}
export { type StylesConfig } from 'react-select';
export const CbMultiSelect: FC<Partial<ReturnType<typeof useStateManager>> & CbMultiSelectProps> = ({
  menuOpenWhileMultiSelect = true,
  selectProps,
  ...props
}) => {
  const [overrideMenuOpen, setOverrideMenuOpen] = useState<boolean>(false);
  const baseSelectProps = useStateManager(props);
  const {
    menuIsOpen
  } = baseSelectProps;
  useEffect(() => {
    if (menuIsOpen && menuOpenWhileMultiSelect) {
      setOverrideMenuOpen(true);
    }
  }, [menuIsOpen]);
  const otherProps = {
    onBlur: () => setOverrideMenuOpen(false),
    ...(overrideMenuOpen && {
      menuIsOpen: true
    })
  };
  return <Select id={props.id} isMulti {...baseSelectProps} {...otherProps} {...selectProps} data-sentry-element="Select" data-sentry-component="CbMultiSelect" data-sentry-source-file="CbMultiSelect.tsx" />;
};